import { isEditableRow } from '../../../shared/columns/tools/headingTools';
import ThirdPartyOwnerEditor from '../editors/ThirdPartyOwnerEditor';
import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import naturalSortComparator from '_legacy/components/grid/comparators/NaturalSortComparator';
import NamePropertyComparator from '_legacy/components/grid/comparators/NamePropertyComparator';
import defaultObjEquals from '_legacy/components/grid/columnDefaults/defaultObjEquals';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import CompanyFormatter from '../../../shared/columns/formatters/CompanyFormatter';
import CompanyKeyCreator from '../../../shared/columns/keyCreators/CompanyKeyCreator';
import suppressOnEdit from '_legacy/components/grid/columnDefaults/suppressOnEdit';

export const thirdPartyOwnerHeading = {
    colId: 'thirdPartyOwner',
    headerName: 'Owner',
    field: 'thirdPartyOwner',
    editable: isEditableRow,
    valueFormatter: CompanyFormatter,
    cellEditorFramework: ThirdPartyOwnerEditor,
    suppressKeyboardEvent: suppressOnEdit(),
    comparator: NamePropertyComparator,
    equals: defaultObjEquals,
    keyCreator: CompanyKeyCreator,
    filter: 'companiesFilter',
    type: ['privatable', 'rumoured'],
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
    width: 120,
    hide: true,
};
